import { TTypeOfCreateGameDeveloperModalWindow } from './createDeveloperModalState/createDeveloperModalContext';
import { ICreateGameDeveloper } from 'types';

export enum CreateGameDeveloperActionTypes {
	CHANGE_NAME = 'CHANGE_NAME',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IChangeName {
	type: CreateGameDeveloperActionTypes.CHANGE_NAME;
	payload: {
		name: string;
	};
}

interface ISetDataForSubmit {
	type: CreateGameDeveloperActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: ICreateGameDeveloper | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateGameDeveloperActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfCreateGameDeveloperModalWindow;
	};
}

interface IResetSelectedControls {
	type: CreateGameDeveloperActionTypes.RESET_FIELDS;
}

export type TCreateGameDeveloperAction =
	| IChangeName
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IResetSelectedControls;
